import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      <div className="bg-gradient-to-r from-red-600 to-red-700 text-white py-2 px-4">
        <div className="max-w-7xl mx-auto flex flex-wrap justify-between items-center text-sm gap-2">
          <a href="https://wa.me/5519989250972" className="flex items-center gap-2 hover:text-red-100 transition-colors whitespace-nowrap">
            <i className="ri-phone-fill"></i>
            <span>(19) 98925-0972</span>
          </a>
          <a href="mailto:sacpaulinia@thejoyschool.com.br" className="flex items-center gap-2 hover:text-red-100 transition-colors">
            <i className="ri-mail-fill"></i>
            <span className="hidden sm:inline">sacpaulinia@thejoyschool.com.br</span>
          </a>
          <div className="flex items-center gap-3">
            <a href="https://www.instagram.com/thejoyschoolpaulinia/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-all hover:scale-110 cursor-pointer">
              <i className="ri-instagram-fill text-base"></i>
            </a>
          </div>
        </div>
      </div>

      <header className={`sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-white'}`}>
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex-shrink-0">
              <img 
                src="https://thejoyschoolvalinhos.com.br/wp-content/uploads/2025/08/logo-novo-scaled.png" 
                alt="The Joy School Paulínia" 
                className="h-12 md:h-16 w-auto object-contain"
              />
            </div>

            <nav className="hidden lg:flex items-center gap-8">
              <button onClick={() => scrollToSection('sobre')} className="text-gray-700 hover:text-red-600 font-medium transition-colors whitespace-nowrap cursor-pointer">
                Sobre Nós
              </button>
              <button onClick={() => scrollToSection('paulinia')} className="text-gray-700 hover:text-red-600 font-medium transition-colors whitespace-nowrap cursor-pointer">
                The Joy Paulínia
              </button>
              <button onClick={() => scrollToSection('pedagogico')} className="text-gray-700 hover:text-red-600 font-medium transition-colors whitespace-nowrap cursor-pointer">
                Pedagógico
              </button>
              <button onClick={() => scrollToSection('atividades')} className="text-gray-700 hover:text-red-600 font-medium transition-colors whitespace-nowrap cursor-pointer">
                Atividades
              </button>
              <button onClick={() => scrollToSection('contato')} className="text-gray-700 hover:text-red-600 font-medium transition-colors whitespace-nowrap cursor-pointer">
                Contatos
              </button>
            </nav>

            <a 
              href="https://wa.me/5519989250972?text=Olá,%20vi%20o%20site%20e%20gostaria%20de%20mais%20informações%20sobre%20a%20The%20Joy%20School%20Paulínia." 
              className="hidden lg:block bg-gradient-to-r from-red-500 to-red-600 text-white px-6 py-3 rounded-full font-semibold hover:from-red-600 hover:to-red-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              MATRÍCULAS ABERTAS!
            </a>

            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden text-gray-700 text-2xl cursor-pointer"
            >
              <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
            </button>
          </div>

          {isMobileMenuOpen && (
            <nav className="lg:hidden mt-4 pb-4 flex flex-col gap-4 border-t pt-4">
              <button onClick={() => scrollToSection('sobre')} className="text-gray-700 hover:text-red-600 font-medium transition-colors text-left cursor-pointer">
                Sobre Nós
              </button>
              <button onClick={() => scrollToSection('paulinia')} className="text-gray-700 hover:text-red-600 font-medium transition-colors text-left cursor-pointer">
                The Joy Paulínia
              </button>
              <button onClick={() => scrollToSection('pedagogico')} className="text-gray-700 hover:text-red-600 font-medium transition-colors text-left cursor-pointer">
                Pedagógico
              </button>
              <button onClick={() => scrollToSection('atividades')} className="text-gray-700 hover:text-red-600 font-medium transition-colors text-left cursor-pointer">
                Atividades
              </button>
              <button onClick={() => scrollToSection('contato')} className="text-gray-700 hover:text-red-600 font-medium transition-colors text-left cursor-pointer">
                Contatos
              </button>
              <a 
                href="https://wa.me/5519989250972?text=Olá,%20vi%20o%20site%20e%20gostaria%20de%20mais%20informações%20sobre%20a%20The%20Joy%20School%20Paulínia." 
                className="bg-gradient-to-r from-red-500 to-red-600 text-white px-6 py-3 rounded-full font-semibold text-center hover:from-red-600 hover:to-red-700 transition-all whitespace-nowrap cursor-pointer"
              >
                MATRÍCULAS ABERTAS!
              </a>
            </nav>
          )}
        </div>
      </header>
    </>
  );
}
